export enum PlatformTheme {
  Homegate = 'HG',
  Immoscout24 = 'IS24',
}

export enum PlatformEnvs {
  dev = 'dev',
  test = 'test',
  prod = 'prod',
}

export const isPlatformIs24 = (): boolean =>
  import.meta.env.VUE_APP_PLATFORM_THEME === PlatformTheme.Immoscout24;

export const isPlatformHg = (): boolean =>
  import.meta.env.VUE_APP_PLATFORM_THEME === PlatformTheme.Homegate;
export const getCurrentPlatformTheme = (): PlatformTheme =>
  isPlatformIs24() ? PlatformTheme.Immoscout24 : PlatformTheme.Homegate;

export const isServer = (): boolean => import.meta.env.SSR;
